if (!customElements.get('hotelier-widget')) {
  customElements.define(
    'hotelier-widget',
    class HotelierWidget extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (window.location.search) {
          this.updateIframeSrc();
        };

        // Only inject the resizer script on Desktop
        const desktopMedia = window.matchMedia('(min-width: 990px)');
        if (desktopMedia.matches) {
          this.loadResizer();
        }

        if (!desktopMedia.matches) {
          this.scrollToView();
        }
      }

      updateIframeSrc() {
        if (!this.iframe) return;

        const params = new URLSearchParams(window.location.search);
        const arrival = params.get('checkInDate');
        const departure = params.get('checkOutDate');
        const adults = params.get('items[0][adults]') || '1';

        // Only proceed if URL contains the required booking dates
        if (arrival && departure) {
          const baseUrl = this.getAttribute('data-base-url');
          const newSrc = `${baseUrl}?locale=en&items[0][adults]=${adults}&checkInDate=${arrival}&checkOutDate=${departure}&trackPage=yes&skin=0`;

          this.iframe.src = newSrc;
        }
      }

      scrollToView() {
        const docReady = (fn) => {
          document.readyState === "loading"
            ? document.addEventListener("DOMContentLoaded", fn)
            : setTimeout(fn, 1);
        };

        setTimeout(() => {
          docReady(() => {
            this.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          });
        }, 1000);
      }

      loadResizer() {
        if (document.querySelector('script[data-ibe-script]')) return;

        const script = document.createElement('script');
        script.src = "//widget.siteminder.com/ibe.min.js";
        script.setAttribute('data-ibe-script', 'true');
        script.async = true;

        script.onload = () => {
          if (window.iFrameResize) {
            window.iFrameResize({ log: false }, '#iFrameResizer0');
          }
        };

        document.head.appendChild(script);
      }

      get iframe() {
        return this.querySelector('iframe');
      }
    }
  );
}

if (!customElements.get('facets-form-memories')) {
  customElements.define(
    'facets-form-memories',
    class FacetsFormMemories extends HTMLElement {
      constructor() {
        super();
        this.baseUrl = this.getAttribute('data-room-url').split('?')[0];
        this.clickEvent = this.handleClickEvent.bind(this);
        this.updateEvent = this.generateUrl.bind(this);
      }

      connectedCallback() {
        this.generateUrl();
        this.addEventListener('facets:update', this.updateEvent);
        this.searchButton?.addEventListener('click', this.clickEvent);
      }

      disconnectedCallback() {
        this.removeEventListener('facets:update', this.updateEvent);
        this.searchButton?.removeEventListener('click', this.clickEvent);
      }

      handleChangeEvent(event) {
        if (!this.contains(event.target)) return;
        this.generateUrl();
      }

      generateUrl() {
        const { arrivalDate = '', departureDate = '', adultsCount = '1' } = this.dataset;
        const finalUrl = `${this.baseUrl}?items[0][adults]=${adultsCount}&checkInDate=${arrivalDate}&checkOutDate=${departureDate}`;
        this.setAttribute('data-room-url', finalUrl);
      }

      handleClickEvent(event) {
        if (!this.searchButton.contains(event.target)) return;
        window.location = this.getAttribute('data-room-url');
      }

      get searchButton() {
        return this.querySelector('button[type="button"]');
      }
    }
  )
}

if (!customElements.get('date-range-picker')) {
  customElements.define(
    'date-range-picker',
    class DateRangePicker extends HTMLElement {
      flatPicker = null;
      unsubscribe = null;

      constructor() {
        super();
        this.clickEvent = this.handleClickEvent.bind(this);
      }

      connectedCallback() {
        this.initRangeDates();
        this.addEventListener('click', this.clickEvent);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.clickEvent);
      }

      initRangeDates() {
        if (!this.flatPickerInput) return;

        const now = new Date();
        // Start date: Today + 28 days
        const arrival = new Date(now);
        arrival.setDate(now.getDate() + 28);
        
        // End date: Today + 29 days
        const departure = new Date(now);
        departure.setDate(now.getDate() + 29);

        const arrivalDate = arrival.toLocaleDateString('en-CA');
        const departureDate = departure.toLocaleDateString('en-CA');

        // const arrivalDate = now.toISOString().split('T')[0];
        // const departureDate = new Date(now.getTime() + 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

        this.flatPickerOptions = {
          mode: "range",
          minDate: "today",
          dateFormat: "Y-m-d",
          defaultDate: [arrivalDate, departureDate],
          onValueUpdate: (selectedDates) => {
            selectedDates.forEach((date, index) => {
              if (this.elsToBind[index]) {
                const formatted = date.toLocaleString('en-US', {
                  month: 'short',
                  day: '2-digit'
                }).replace(' ', ', ');

                this.elsToBind[index].textContent = formatted;
              }

              if (!this.facetsFormMemories) return;
              const originalDate = date.toLocaleDateString('en-CA');
              index === 0 ?
                this.facetsFormMemories.setAttribute('data-arrival-date', originalDate) :
                this.facetsFormMemories.setAttribute('data-departure-date', originalDate);
            });

            this.facetsFormMemories.dispatchEvent(new CustomEvent('facets:update', { bubbles: true }));
          }
        };

        this.flatPicker = flatpickr(this.flatPickerInput, this.flatPickerOptions);
      }

      handleClickEvent(event) {
        if (!this.contains(event.target)) return;
        this.flatPickerInput.click();
      }

      get elsToBind() {
        return this.querySelectorAll('[data-bind-element]');
      }

      get facetsFormMemories() {
        return this.closest('facets-form-memories');
      }

      get flatPickerInput() {
        return this.querySelector('.flatpickr-input');
      }
    }
  )
}

if (!customElements.get('product-options')) {
  customElements.define(
    'product-options',
    class ProductOptions extends HTMLElement {
      constructor() {
        super();
        this.changeEvent = this.handleCahngeEvent.bind(this);
      }

      connectedCallback() {
        this.handleCustomSelects();
        this.guestSelect?.addEventListener('change', this.changeEvent);
      }

      disconnectedCallback() {
        this.guestSelect?.removeEventListener('change', this.changeEvent);
      }

      handleCahngeEvent(event) {
        if (!this.guestSelect.contains(event.target)) return;
        this.facetsFormMemories?.setAttribute('data-adults-count', event.target.value.split(' ')[0]);
        this.facetsFormMemories.dispatchEvent(new CustomEvent('facets:update', { bubbles: true }));
      }

      handleCustomSelects() {
        let mainSelect = document.querySelector('.main-select-div select');
        let mainSelectOptions = document.querySelectorAll('.main-select-div select option');
        let trigerButton = document.querySelector('.triger-select');
        let trigerButtonText = document.querySelector('.triger-select .triger-select-text');
        let demoSelect = document.querySelector('.triger-select-dropdown');
        let demoOptions = document.querySelectorAll('.triger-select-dropdown li');

        // mainSelect.addEventListener('change', function () {
        //   console.log('Main Select Changed:', mainSelect.value);
        // });

        trigerButton.addEventListener('click', function () {
          demoSelect.classList.toggle('hidden');
        });

        demoOptions.forEach(function (demoItem) {
          demoItem.addEventListener('click', function () {
            trigerButtonText.textContent = demoItem.textContent;
            demoSelect.classList.add('hidden');

            mainSelectOptions.forEach(function (mainItem) {
              if (mainItem.textContent.trim() === demoItem.textContent.trim()) {
                mainSelect.value = mainItem.value; // use value, not textContent
                mainSelect.dispatchEvent(new Event('change')); // trigger change event
              }
            });
          });
        });
      }

      get facetsFormMemories() {
        return this.closest('facets-form-memories');
      }

      get guestSelect() {
        return this.querySelector('select');
      }
    }
  )
}